import CelebrationWall from 'Pages/Cms/Elements/CelebrationWall';
import OnDemand from 'Pages/Cms/Elements/OnDemand';

import AdminCmsElementsIndex from 'Pages/Admin/Cms/Elements';
import AdminCmsElementsShow from 'Pages/Admin/Cms/Elements/show';
import AdminCmsElementsStore from 'Pages/Admin/Cms/Elements/store';
import AdminCmsElementFieldsStore from 'Pages/Admin/Cms/Elements/Fields/store';
import AdminCmsElementsRecordsIndex from 'Pages/Admin/Cms/Elements/Records';
import AdminCmsElementsRecordsStore from 'Pages/Admin/Cms/Elements/Records/store';

export default [
	// Frontend
	// { path: '/celebration-wall', component: CelebrationWall, guards: ['auth'] },
	 { path: '/on-demand', component: OnDemand },

	// Admin
	{ path: '/admin/cms/elements', component: AdminCmsElementsIndex, guards: ['admin'] },
	{ path: '/admin/cms/elements/show/:element?', component: AdminCmsElementsShow, guards: ['admin'] },
	{ path: '/admin/cms/elements/store/:element?', component: AdminCmsElementsStore, guards: ['admin'] },
	{ path: '/admin/cms/elements/fields/store/:element/:field?', component: AdminCmsElementFieldsStore, guards: ['admin'] },
	{ path: '/admin/cms/elements/records/:element?', component: AdminCmsElementsRecordsIndex, guards: ['admin'] },
	{ path: '/admin/cms/elements/records/store/:element/:record?', component: AdminCmsElementsRecordsStore, guards: ['admin'] },
];
